import {
  Avatar,
  Card,
  Col,
  List,
  message,
  Row,
  Space,
  Tooltip,
  Typography,
} from "antd";
import "./chatwindow.css";
import { CopyIcon, EraLogoIcon, UserIcon } from "../../shared/utils";
import {
  DislikeFilled,
  DislikeOutlined,
  LikeFilled,
  LikeOutlined,
} from "@ant-design/icons";
import { ChatModel } from "../../shared/axios";
import { useEffect, useRef,useState } from "react";
import React from "react";




const { Paragraph, Text } = Typography;

export const ChatWindow = ({
  chat_messages,
  typingStopped,
  handleFeedback,
  handleTypingCompleted,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const messagesEndRef = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const typewriterInstance = useRef(null);

  const scrollToBottom = () => {
    if (!isUserScrolling && messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  };

  const handleScroll = () => {
    if (!messagesEndRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = messagesEndRef.current;
    // Check if user is at the bottom
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;

    // Update the scrolling state
    setIsUserScrolling(!isAtBottom);
  };

  useEffect(() => {
    const lastMessage = chat_messages[chat_messages.length - 1];

    let scrollInterval;
    if (lastMessage.typingCompleted == null) {
      scrollInterval = setInterval(scrollToBottom, 100);
    }

    if (typingStopped) {
      console.log(typingStopped, "if condition typingStopped");
      handleTypingCompleted(false);
      if (typewriterInstance.current != null) {
        typewriterInstance.current.stop();
      }
    }

    return () => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
        scrollToBottom();
      }
    };
  }, [chat_messages,  handleTypingCompleted]);

  // Submit the feedbacks and gets the succes response
  const handleUserFeedback = async (responseId, feedSelected, botID) => {
    const response = await ChatModel.update_interaction({
      response_id: responseId,
      action: feedSelected,
    });
    if (response?.status !== "success") {
      messageApi.open({
        type: "error",
        content: "Something Went Wrong!",
      });
    }

    if (feedSelected !== "copies") {
      handleFeedback(feedSelected, botID);
    }
  };
  
  return (
    <Row justify={"space-evenly"} className="chat-window" ref={messagesEndRef} onScroll={handleScroll}>
      {contextHolder}

      <EraLogoIcon className="chat-lottie-logo-animation" />
      <div className="chat-window-list">
        <List
          dataSource={chat_messages}
          renderItem={(item) => (
            <List.Item className="chat-list">
              <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                <Avatar
                  className={`avatar-${item.human_type}`}
                  size={{ xs: 30, sm: 30, md: 50, lg: 40, xl: 40, xxl: 50 }}
                  icon={
                    item.human_type === "user" ? (
                      <UserIcon className="user-icon" />
                    ) : (
                      <EraLogoIcon className="era-logo-icon" />
                    )
                  }
                />
              </Col>
              <Col
                xs={
                  item.human_type === "bot" &&
                  typeof item.content === "string" &&
                  item.content !== "" &&
                  19
                }
                sm={
                  item.human_type === "bot" &&
                  typeof item.content === "string" &&
                  item.content !== "" &&
                  20
                }
                md={
                  item.human_type === "bot" &&
                  typeof item.content === "string" &&
                  item.content !== "" &&
                  22
                }
                lg={
                  item.human_type === "bot" &&
                  typeof item.content === "string" &&
                  item.content !== "" &&
                  22
                }
                xl={
                  item.human_type === "bot" &&
                  typeof item.content === "string" &&
                  item.content !== "" &&
                  22
                }
              >
               <Card>
                {typeof item.content === "object" ? (
                  item.content // Directly render if it's an object
                ) : (
                  <div>{item?.content}</div>
                )}
                {item.human_type === "bot" &&
                  item?.responseID &&
                  item?.typingCompleted && (
                    <UserActions
                      answer={item?.content}
                      responseID={item?.responseID}
                      feedback_response={item?.feedbackAccepted}
                      handleUserFeedback={handleUserFeedback}
                      botID={item?.bot_id}
                    />
                  )}
              </Card>
              </Col>
            </List.Item>
          )}
        />
      </div>
    </Row>
  );
};

const UserActions = ({
  answer,
  responseID,
  feedback_response,
  handleUserFeedback,
  botID,
}) => {

  function getTextContent(element) {
    if (typeof element === 'string') {
      return element; // If it's already a string, return it
    }
  
    if (React.isValidElement(element)) {
      let text = '';
      React.Children.forEach(element.props.children, (child) => {
        text += getTextContent(child); // Recursively get the text from the children
      });
      return text;
    }
  
    return '';
  }

  return (
    <Row justify={"end"} className="user-actions">
      <Space>
        {feedback_response.length < 1 ? (
          <Space>
            <LikeOutlined
              className="chat-icon-outlined"
              onClick={() => handleUserFeedback(responseID, "likes", botID)}
            />
            <DislikeOutlined
              className="chat-icon-outlined"
              onClick={() => handleUserFeedback(responseID, "dislikes", botID)}
            />
          </Space>
        ) : (
          <Space>
            <Text className="feedback-note">Thanks for your feedback!</Text>
            {feedback_response.includes("likes") && (
              <LikeFilled className="chat-icon-filled" />
            )}
            {feedback_response.includes("dislikes") && (
              <DislikeFilled className="chat-icon-filled" />
            )}
          </Space>
        )}

        <Paragraph
          className="copy-icon-paragraph"
          copyable={{
            icon: [
              <CopyIcon
                className="chat-icon-outlined"
                onClick={() => handleUserFeedback(responseID, "copies")}
              />,
            ],
            tooltips: false,
            text: getTextContent(answer),
          }}
        />
      </Space>
    </Row>
  );
};



